import { IShoppingBagData } from "../../types/ShoppingBag";
import { Box, Card, CardContent, Divider, Typography } from "@mui/material";
import { Colors } from "../../helpers/Consts";
import { getDataExtensoSimples } from "../../helpers/Utils";
import OrderItemDetails from "../../components/OrderDetails/orderItemDetails";
import IfWithdrawShowAddress from "./ifWithdrawShowAddress";

type Props = {
  order: IShoppingBagData;
};

function SingleOrderDetailsForDialog({ order }: Props) {
  return (
    <>
      <Box
        sx={{
          marginBottom: 2,
        }}
      >
        <Typography
          sx={{ fontSize: "0.7rem" }}
          fontWeight="700"
          color={Colors.baseTextColor}
        >
          {getDataExtensoSimples(new Date(order.created_at).toLocaleDateString("pt-Br"))}
        </Typography>
        <Card variant="outlined">
          <CardContent>
            <Box sx={{ display: "flex" }}>
              <Typography
                fontSize="0.7rem"
                color={Colors.baseTextColor}
                fontWeight="300"
              >
                Pedido #
              </Typography>
              <Typography
                fontSize="0.7rem"
                color={Colors.grayTextColorDarkestDark}
                fontWeight="700"
              >
                {order.id}
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              <Typography
                fontSize="0.6rem"
                color={Colors.grayTextColorDarkest}
              >
                {new Date(order.created_at).toLocaleString(
                  "pt-Br",
                )}
              </Typography>
            </Box>
            <Box sx={{ display: "flex" }}>
              <Typography
                fontSize="0.6rem"
                color={
                  order.status !== 13
                    ? Colors.orangePrimary
                    : "red"
                }
                fontWeight="700"
              >
                {order.status_description === "Criado"
                  ? "Sacola em Aberto"
                  : order.status_description}
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              <Typography
                fontSize="0.6rem"
                color={
                  order.status !== 13
                    ? Colors.orangePrimary
                    : "red"
                }
              >
                {order.status === 13
                  ? new Date(
                    order.cancelled_at,
                  ).toLocaleString("pt-Br")
                  : new Date(order.updated_at).toLocaleString(
                    "pt-Br",
                  )}
              </Typography>
            </Box>
            <Divider sx={{ padding: "5px" }} />

              <Box
                component="img"
                sx={{ borderRadius: "50%", height: "50px" }}
                src={order.placeInfo.logo_image}
                alt="alt"
              />
              <Box p={1} marginLeft={"10px"}>
                <Typography
                  fontSize="0.8rem"
                  fontWeight={"700"}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {order.placeInfo.name}
                </Typography>
                <Typography
                  fontSize="0.6rem"
                  color={Colors.baseTextColor}
                >
                  {order.placeInfo.short_description}
                </Typography>
              </Box>


            <IfWithdrawShowAddress order={order} />
            <Divider sx={{ padding: "5px" }} />
            <Box padding={"10px 0px"}>
              {order.items.map((item) => (
                <Box
                  sx={{
                    marginBottom: "6px",
                  }}
                  key={item.id}
                >
                  <OrderItemDetails singleItem={item} />
                </Box>
              ))}
            </Box>
            <Divider sx={{ padding: "5px" }} />
            <Box paddingTop="8px">
              <Box display={"flex"}>
                <Typography
                  fontSize="0.7rem"
                  color={Colors.baseTextColor}
                >
                  Valor dos Itens
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="0.7rem"
                  fontWeight={700}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {order.total.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Typography>
              </Box>
            </Box>
            <Box paddingTop="2px">
              <Box display={"flex"}>
                <Typography
                  fontSize="0.7rem"
                  color={Colors.baseTextColor}
                >
                  Desconto
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="0.7rem"
                  fontWeight={700}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {order.discount_value.toLocaleString(
                    "pt-br",
                    {
                      style: "currency",
                      currency: "BRL",
                    },
                  )}
                </Typography>
              </Box>
            </Box>
            <Box paddingTop="2px">
              <Box display={"flex"}>
                <Typography
                  fontSize="0.7rem"
                  color={Colors.baseTextColor}
                >
                  Total a Pagar
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="0.7rem"
                  fontWeight={700}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {order.total.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Typography>
              </Box>
            </Box>
            <Box paddingTop="2px">
              <Box display={"flex"}>
                <Typography
                  fontSize="0.7rem"
                  color={Colors.baseTextColor}
                >
                  Enviar Descartáveis
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="0.7rem"
                  fontWeight={700}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {order.take_disposable ? "Sim" : "Não"}
                </Typography>
              </Box>
            </Box>
            <Box paddingTop="2px">
              <Box display={"flex"}>
                <Typography
                  fontSize="0.7rem"
                  color={Colors.baseTextColor}
                >
                  Forma de Pgto
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="0.7rem"
                  fontWeight={700}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {order.paymentTypeInfo
                    ? order.paymentTypeInfo.description
                    : ""}
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ padding: "5px" }} />
            <Box paddingTop="10px">
              <Box display={"flex"}>
                <Typography
                  fontSize="0.7rem"
                  color={Colors.baseTextColor}
                >
                  Avaliação Pendente
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="0.7rem"
                  fontWeight={700}
                  color={Colors.grayTextColorDarkestDark}
                >
                  Pendente
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

export default SingleOrderDetailsForDialog;